import { Matrices, useDeleteMatrixMutation } from 'prove-common'
import { ReferenceTable } from '../reference-table/ReferenceTable'

export const MatricesTable = ({ matrices }: { matrices: Matrices }) => {
  const remove = useDeleteMatrixMutation()
  return (
    <ReferenceTable
      rows={matrices}
      title='Matriser'
      emptyTitle='Ingen matriser'
      columns={[
        { key: 'name', label: 'Navn', value: (row) => row.name },
        { key: 'code', label: 'Kode', value: (row) => row.code },
        { key: 'id', label: 'ID', value: (row) => row.id, copy: true }
      ]}
      name={(row) => row.name}
      onDelete={(id) => remove.mutateAsync(id)}
    />
  )
}
